import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private spinner: NgxSpinnerService, @Inject(PLATFORM_ID) private platformId: Object) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isSkip = req.headers.has('skipLoad');
    const isBrowser = isPlatformBrowser(this.platformId);

    if (isSkip || !isBrowser) {
      return next.handle(req).pipe(finalize(() => {}));
    } else {
      this.spinner.show();
      return next.handle(req).pipe(
        finalize(() => {
          setTimeout(() => {
            this.spinner.hide();
          }, 500);
        })
      );
    }
  }
}
